<template>
  <article class="footer">
    <div class="bj">
      <div class="title">{{ title }}</div>
      <button @click="goTop()">免费体验</button>
    </div>
  </article>
</template>

<script>
export default {
  data() {
    return {
      title: '房地产行业电子签名解决方案',
    }
  },
  methods: {
    goTop() {
      if (document.body.scrollIntoView) {
        document.body.scrollIntoView({ behavior: 'smooth' })
      } else {
        document.body.scrollTop = document.documentElement.scrollTop = 0
      }
    },
  },
}
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  height: 200px;
  text-align: center;
  background: #e61717;
  overflow: hidden;
  .bj {
    width: 1180px;
    height: 200px;
    margin: 0 auto;
    position: relative;
    background-image: url(../../../assets/images/real-estate/foot-bj.png);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .title {
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 40px;
    padding-top: 48px;
    text-align: center;
  }

  button {
    margin: 24px auto 0;
    width: 135px;
    height: 42px;
    border: 1px solid #ffffff;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 22px;
    border-radius: 2px;

    &:hover {
      background: #ffffff;
      border: 1px solid #ffffff;
      color: #e61717;
    }
  }
}
</style>
